import styled from 'styled-components';

export const LiteTradeSearchResultListStyled = styled.div`
    flex: 1;

    [data-test-id="virtuoso-scroller"] {
        flex: 1;
        margin-right: -16px;

    }
    
    [data-test-id="virtuoso-item-list"] {
        padding-right: 16px;
    }
`;
